import React from "react";
import aboutUs from "../images/about-us/abus.jpg";
import stall from "../images/about-us/stall.png";
import Colonel from "../images/about-us/Col.png";
import "../styles/aboutUs.css";

export default function AboutUs() {
  return (
    <section id="aboutUs">
      <img src={aboutUs} className="w-100" alt="..." loading="lazy" />
      <div className="mcare-about-us">
        <div className="container">
          <h2 align="left" className="pb-3">
            Welcome to <span style={{ color: "#005598" }}>METAK Healthcare India (Pvt.) Ltd.</span>
          </h2>
          <p>
            <span className="showInABlock">M</span>ETAK Healthcare India Pvt. Ltd. is established to be the Healthcare Company which focuses on
            Quality Aids to enable people to lead a healthy, painless, energetic, life and wish them a speedy recovery. METAK Healthcare India Pvt.
            Ltd. is growing and serving the Patients suffering from various Orthopedic Disorders & Ailments and thus provides patients faster active
            lifestyle.
          </p>
          <p className="mb-5">
            We pride ourselves in our customer-centered approach from start to finish. From the convenience of extended business hours to the
            professional and friendly customer care atmosphere, we treat each customer like we would expect to be treated - with utmost care and
            respect.
          </p>

          <div className="row">
            <p>
              <strong>To achieve our goals of superior quality, safety and affordability we focus on:</strong>
            </p>
            <div className="col-lg-7 col-m-12">
              <ul className="about-us-ul">
                <li>State of art manufacturing facilities</li>
                <li>Systematic, efficient approach to manufacturing</li>
                <li>3-D Computer Designing</li>
                <li>Well trained and experienced committed professionals and sales force</li>
              </ul>
              <p>
                Our Model is proving very successful in our relationships with patients, home settings, referral sources, distributors, dealers,
                chemists and industries.Active Participation in all Distributor Search India Meetings.
              </p>
              <p>
                All our distributors, customers, etc. are supported for order placement, product delivery and after sale service by a dedicated team
                of highly skilled employees. We uphold our motto 'Quality Our Priority' and continue to sustain and rise to our customer needs with a
                Wide Range of Acceptable designs, Quality Products, Value for Money, Healthy Dealer Margins, Safety and an Honest approach for
                customer satisfaction.
              </p>
            </div>
            <div className="col-lg-5 col-m-12">
              <img src={stall} className="img-fluid ps-5 pb-2" style={{ height: "320px", alignSelf: "start" }} alt="..." loading="lazy" />
            </div>
          </div>
          <div className="row pt-5">
            <div className="col-md-7">
              <h2 align="left" style={{ color: "#005598" }}>
                METAK HEALTHCARE INDIA PVT. LTD.
              </h2>
              <ul className="about-us-ul">
                <li>(An ISO 9001:2008 Certified Company)</li>
                <li>TIN:07180449095</li>
                <li>GSTIN: 07AAICM2070K1ZD</li>
                <li>Drug License No.: SW (0683)/13/W, Name: Sh. Abhishek Sinha, Company: METAK Healthcare India Pvt. Ltd.</li>
                <li>PAN: AAICM2070K</li>
                <li>Address: C-6/9, Near C Block Market, Vasant Vihar, New Delhi - 110057</li>
                <li>Phone: +919312929895, +918447214545, +91146560397</li>
                <li>Email: info@metakindia.com, director@metakindia.com, sales@metakindia.com</li>
                <li>Web: www.metakindia.com</li>
              </ul>
              <h6 align="left">Company's bank details are as under:</h6>
              <ul className="about-us-ul">
                <li>
                  A/C: METAK Healthcare India Pvt. Ltd., 006505005018. ICICI Bank, C-17, C Block Market, Vasant Vihar, New Delhi - 110057, IFSC:
                  ICIC0000065
                </li>
                <li>
                  A/C: METAK Healthcare India Pvt. Ltd., 3111862277. KOTAK MAHINDRA Bank, M-3, Hauz Khas Enclave, Aurobindo Marg , New Delhi - 110016,
                  IFSC: KKBK0004591
                </li>
              </ul>
            </div>
            <div className="col-md-5 px-md-4">
              <h2 align="left" style={{ color: "#005598" }}>
                Founder and Managing Director
              </h2>
              <p>
                <strong>
                  Col. Kartikey Sinha (Retd.), BSc. Engg. (AMU), MTech (Indian Armed Forces), Communication and Advanced Warfare (Hungary). Presently:
                  Founder and Managing Director of METAK Healthcare India Pvt. Ltd., having immense experience in Repair and Maintenance of Medical
                  equipment as Retired Chief Maintability Engineer for Armed forces (Army, Navy and Air force) providing Equipment's repair and
                  maintenance
                </strong>
              </p>
              {/* <span className="text-start"> */}
              <img src={Colonel} className="aboutus-img" alt="..." loading="lazy" />
              {/* </span> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
